import React from 'react';

import AppVars from '../../AppVars.js';
import Logger from '../../Logger.js';

import {register} from 'account-portal-library/lib/appleSignIn';
import {uniqueCheck} from 'account-portal-library/lib/idmRegister';
import {parseCookies, validateSessionToken, isValidGoToURL} from 'account-portal-library/lib/helperFunctions';

import TORegisterAppleFormView from '../Views/TO/Apple/RegisterAppleFormView'
import { getGotoUrlFromCookies } from '../../gotoUrl.js';

let appVars = AppVars.getInstance()
let logger = Logger.getInstance();

const VALID_FAILURE_URL = ["/noemail"]

const INPUT_VALIDATION = {
    "FIRST_NAME" : "^[a-zA-Z][a-zA-Z\\s'\-]{0,12}[a-zA-Z]$",
    "LAST_NAME" : "^[a-zA-Z][a-zA-Z\\s'\-]{0,27}[a-zA-Z]$",
    "PHONE" : "^(?!0)[0-9]{10}$"
}

class RegisterAppleForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ...props,
            firstName:"",
            lastName: "",
            phone: "",
            loading: false,
            isFirstNameValid: null,
            isLastNameValid: null,
            isPhoneValid: null,
            isResponseValid: null,
            isPhoneAvailable: null,
            firstNameFocus: false,
            lastNameFocus: false,
            phoneFocus: false,
            floatFirstName: true,
            floatLastName: true,
            floatPhone: true,
        };
        this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
        this.handleLastNameChange = this.handleLastNameChange.bind(this);
        this.handlePhoneChange = this.handlePhoneChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.setFocusFirstName = this.setFocusFirstName.bind(this);
        this.removeFocusFirstName = this.removeFocusFirstName.bind(this);
        this.setFocusLastName = this.setFocusLastName.bind(this);
        this.removeFocusLastName = this.removeFocusLastName.bind(this);
        this.setFocusPhone = this.setFocusPhone.bind(this);
        this.removeFocusPhone = this.removeFocusPhone.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.onBlurFirstName = this.onBlurFirstName.bind(this);
        this.onBlurLastName = this.onBlurLastName.bind(this);
        this.onBlurPhone = this.onBlurPhone.bind(this);
    }


    async handleFormSubmit(event){
        //Prevent default submit button behavior
        event.preventDefault();

        this.setState({loading: true})
        //Check that form inputs are valid
        var valid = this.validateFormInput()
        this.setState({loading: false})
        
        if (valid) {
            //var availableResponse= await uniqueCheck(this.state.phone, appVars.getIDMBaseURL());
            //this.setState({isPhoneAvailable: availableResponse.state.available})
            //if (availableResponse.state.available === true){
            this.setState({loading: true})
            var response = await register(this.props.payload, this.state.firstName, this.state.lastName, this.state.phone, this.props.style, appVars.getBaseUrl(), appVars.getRealm(), appVars.getAppleSignInTree(), appVars.getDomain(), appVars.getName() )
            logger.log("test", "Register Apple Response")
            logger.log("test", response)
            this.handleLoginResponse(response)
            //}
            // var emailAvailabilityResponse = await this.checkEmailAvailability()
            // this.setState({loading: false})
            // if (this.state.isResponseValid){
            //     if(this.state.isEmailAvailable){
            //         this.props.setFirstName(this.state.firstName);
            //         this.props.setLastName(this.state.lastName);
            //         this.props.setEmail(this.state.email);
            //         this.props.displayForm("PASSWORD")
            //     } else if (!this.state.isEmailAvailable){
            //         this.props.setEmail(this.state.email);
            //         this.props.displayForm("EXISTS")
            //     } else {
            //         this.setState({isResponseValid: false})
            //     }               
            // }
        } 
    }

    handleUniqueCheckResponse(response){
        if(response.status < 299) {
            if (response.response.code === 200){
                this.setState({isPhoneAvailable: true})
            } else {
                this.setState({isPhoneAvailable: false})
            }
        } else {
            this.setState({isPhoneValid: false})
        }
    }

    handleLoginResponse(loginResponse){
        if (loginResponse.status < 299) {
            logger.log('stage', "success")
            this.handleSuccess(loginResponse);
        } else {
            logger.log('stage', "failure")
            this.handleFailure(loginResponse);
        }
    }

    handleFailure(loginResponse){
        var failureUrl = loginResponse.failureUrl
        window.location.replace(appVars.getUnknownErrorURL(this.props.style));
    }

    async handleSuccess(loginResponse){
        var tokenValid = await this.checkToken(loginResponse);
        logger.log('stage', tokenValid)

        if (tokenValid){
            const gotoUrl = getGotoUrlFromCookies(['T', 'S']);
            window.location.replace(gotoUrl);
        } else {
            window.location.replace(appVars.getUnknownErrorURL(this.props.style));
        }
        
    }

    async checkToken(loginResponse){
        try {
            var tokenId = loginResponse.response.tokenId
            if (tokenId != null){
                logger.log("test", tokenId)
                var validateResponse = await validateSessionToken(tokenId, appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
                logger.log("test", validateResponse)
                return validateResponse.response.valid;
            } else{
                return false
            }
        }
        catch{
            return false
        }
        
    }


    validateFormInput(){
        var isFirstNameValid = this.validateInput(this.state.firstName, "FIRST_NAME");
        var isLastNameValid = this.validateInput(this.state.lastName, "LAST_NAME");
        var isPhoneValid = this.validateInput(this.state.phone, "PHONE");
        this.setState({isFirstNameValid: isFirstNameValid});
        this.setState({isLastNameValid: isLastNameValid});
        this.setState({isPhoneValid: isPhoneValid});
        return (isFirstNameValid && isLastNameValid && isPhoneValid)
    }

    handleErrorResponse(err){
        this.setState({isResponseValid: false})
    }

    handleResponse(emailAvailabilityResponse){
        if(emailAvailabilityResponse.status > 299){
            this.setState({isResponseValid: false})
        }
        else{
            this.setState({isResponseValid: true})
            this.setState({isEmailAvailable: emailAvailabilityResponse.data.isAvailable})
        }
    }

    validateInput(inputValue, inputType){
        var regex = RegExp(INPUT_VALIDATION[inputType])
        if (regex.test(inputValue)){
            return true;
        }
        return false;
    }

    handleFirstNameChange(event){
        this.setState({
            firstName: event.target.value,
        })
        this.setState({isFirstNameValid: this.validateInput(event.target.value, "FIRST_NAME")}) 
    }

    handleLastNameChange(event){
        this.setState({
            lastName: event.target.value
        });
        this.setState({isLastNameValid: this.validateInput(event.target.value, "LAST_NAME")})
    }

    
    handlePhoneChange(event) {
        this.setState({
            phone: event.target.value,
        }, () => {
            if (this.state.isPhoneAvailable === false) {
                this.setState({
                    isPhoneAvailable: true,
                    isPhoneValid: this.validateInput(this.state.phone, "PHONE")
                })
            } else if (this.state.isPhoneValid === false){
                this.setState({
                    isPhoneValid: this.validateInput(this.state.phone, "PHONE")
                })
            }
        })
    }

    setFocusFirstName(event){
        this.setState({firstNameFocus: true})
        this.setState({floatFirstName: false})
    }

    removeFocusFirstName(){
        this.setState({firstNameFocus: false})
    }

    setFocusLastName(event){
        this.setState({lastNameFocus: true})
        this.setState({floatLastName: false})
    }

    removeFocusLastName(){
        this.setState({lastNameFocus: false})
    }

    setFocusPhone(event){
        this.setState({phoneFocus: true})
        this.setState({floatPhone: false})
    }

    removeFocusPhone(){
      this.setState({phoneFocus: false})
    }

    onBlurFirstName(){
        if (this.state.firstName === ""){
            this.setState({floatFirstName: true})
        }else{
            this.setState({floatFirstName: false})
        }
        this.removeFocusFirstName();

        this.setState({isFirstNameValid: this.validateInput(this.state.firstName, "FIRST_NAME")})
    }

    onBlurLastName(){
        if (this.state.lastName === ""){
            this.setState({floatLastName: true})
        }else{
            this.setState({floatLastName: false})
        }
        this.removeFocusLastName();
        this.setState({isLastNameValid: this.validateInput(this.state.lastName, "LAST_NAME")})
    }

    onBlurPhone(){
        if (this.state.phone === ""){
            this.setState({floatPhone: true})
        }else{
            this.setState({floatPhone: false})
        }
        this.removeFocusPhone();
        this.setState({
            isPhoneValid: this.validateInput(this.state.phone, "PHONE")
        })
    }

    hideModal(){
        this.setState({isResponseValid: null})
    }
    
    render(){
            return(
                <TORegisterAppleFormView
                style = {this.props.style}
                firstName = {this.state.firstName}
                lastName = {this.state.lastName}
                phone = {this.state.phone}
                loading = {this.state.loading}
                isFirstNameValid = {this.state.isFirstNameValid}
                isLastNameValid = {this.state.isLastNameValid}
                isPhoneValid = {this.state.isPhoneValid}
                isPhoneAvailable = {this.state.isPhoneAvailable}
                isResponseValid = {this.state.isResponseValid}
                handleFirstNameChange = {this.handleFirstNameChange}
                handleLastNameChange = {this.handleLastNameChange}
                handlePhoneChange = {this.handlePhoneChange}
                handleFormSubmit = {this.handleFormSubmit}
                firstNameFocus = {this.state.firstNameFocus}
                setFocusFirstName = {this.setFocusFirstName}
                removeFocusFirstName = {this.removeFocusFirstName}
                lastNameFocus = {this.state.lastNameFocus}
                setFocusLastName = {this.setFocusLastName}
                removeFocusLastName = {this.removeFocusLastName}
                phoneFocus = {this.state.phoneFocus}
                setFocusPhone = {this.setFocusPhone}
                removeFocusPhone = {this.removeFocusPhone}
                hideModal = {this.hideModal}
                onBlurFirstName = {this.onBlurFirstName}
                onBlurLastName = {this.onBlurLastName}
                onBlurPhone = {this.onBlurPhone}
                floatFirstName = {this.state.floatFirstName}
                floatLastName = {this.state.floatLastName}
                floatPhone = {this.state.floatPhone}
                />
            );

    }

}




export default RegisterAppleForm;